import * as React from 'react';
import { Form } from '../form';
import { style } from 'typestyle';
import { px } from 'csx';
import { Component, observer, deps, inject } from '../../lib/component';
import { styles } from './styles';
import { ButtonPill } from '../button-pill';
import { SVGIcon } from '../svg-icon';
import { colorDarkGreen } from '../../theme/color';
import { autorun } from 'mobx';

@inject(deps)
@observer
export class CouponForm extends Component<Record<string, never>> {
  disposers = [];

  constructor(props) {
    super(props);

    this.state = {
      value: '',
      interacted: false,
      disabled: false,
    };
  }

  componentDidMount() {
    this.disposers.push(
      autorun(() => {
        const apiValue = this.props.model.coupon.code;
        if (!this.state.interacted && typeof apiValue === 'string' && apiValue.length > 0) {
          this.setState(
            {
              value: apiValue,
              disabled: true,
            },
            () => this.apply(),
          );
        }
      }),
    );
  }

  componentWillUnmount() {
    this.disposers.forEach((dispose) => dispose());
  }

  apply(event?) {
    if (event) {
      event.preventDefault();
    }
    this.props.model.coupon.code = this.state.value;
    this.props.controller.checkout.cancelOrder();
    this.props.controller.checkout.deferredLoadOrder();
  }

  onChange(event) {
    this.setState({
      value: event.target.value,
    });

    if (!this.state.interacted) {
      this.setState({
        interacted: true,
      });
    }
  }

  render() {
    const { value, disabled } = this.state;

    const applied = this.state.value.length > 0 && this.props.model.coupon.code === this.state.value;

    return (
      <form onSubmit={this.apply.bind(this)} className={styles.checkoutSummaryCouponForm}>
        <label>
          Coupon code:
          <input
            type="text"
            value={value}
            onChange={this.onChange.bind(this)}
            disabled={disabled}
            placeholder="Enter code"
          />
        </label>
        <ButtonPill primary type="submit" xsmall tertiary disabled={applied}>
          {applied ? (
            <span>
              Applied <SVGIcon.Checkmark color={colorDarkGreen.toHexString()} size={10} />
            </span>
          ) : (
            'Apply'
          )}
        </ButtonPill>
      </form>
    );
  }

  static styles = {
    form: style({
      maxWidth: px(640),
    }),
  };
}
